import { create } from 'zustand'

export const useStore = create((set) => ({
  config: {},
  setConfig: (config) => set(() => ({ config })),
}))
